import { ELEMENT_TYPES, ELEMENT_TYPES_BY_KEY } from 'cg/components/documents/editor/slate/types'
import { Transforms } from 'vendor/slate'
import { v4 as uuidv4 } from 'uuid'

const insertAppLink = (editor, path, type, options) => {
  const appLink = {
    type,
    title: options.title,
    link_without_namespace_and_workspace: options.link_without_namespace_and_workspace || null,
    absolute_link: options.absolute_link || null,
    publish_link: options.publish_link || null,
    publish_absolute_link: options.publish_absolute_link || null,
    publish_display_link: options.publish_display_link || null,
    children: [{ uuid: uuidv4(), text: '', parent: { type } }]
  }

  Transforms.insertNodes(editor, appLink, { at: path })
}

export { insertAppLink }
